/**
 * @todo define the correct way for error management
 */

const { log, error } = console;

export default {
  log,
  error,
};
